export const clear = () => {
	window.myTSAccountProtection.clearUser()
}
